/**
 * Permissions provider service
 */
import { Injectable } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { IPermission } from './types/permission.type';
import { map } from 'rxjs/operators';

export interface IPermissionsProvider {
  permissions$: Observable<IPermission[]>;
}

/**
 * PermissionsProviderService retrieves permissions set from store and provides Observable for
 * PermissionsService. Use custom provider with own service implementation to override permissions
 * retrieval functionality. Custom provider should implements IPermissionsProvider.
 */
@Injectable()
export class PermissionsProviderService implements IPermissionsProvider {
  public permissions$: Observable<IPermission[]>;
  @select(['userSession', 'userPermissions', 'items'])
  public userPermissions$: Observable<any>;

  public constructor() {
    this.permissions$ = this.userPermissions$.pipe(
      map((userPermissions) => {
        return userPermissions;
      }),
    );
  }
}
